/*
 * Copyright 2024
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2024.5.6 at 18:17
 */

// import menu_init from './modules/menu';
import nav_init from './modules/navigation';
import scroll_top_init from './modules/scroll-top';
import a11tyMenu from './modules/a11ty-menu';
import logoColor from './modules/logo-color';
import iosFix from './modules/ios-fix';
// import NewsletterComponent from './webc/newsletter';

// new NewsletterComponent();

window.addEventListener('beforeprint', (event) => {
    document.querySelector('body').classList.add('print');
});

window.addEventListener('afterprint', (event) => {
    document.querySelector('body').classList.remove('print');
});

document.addEventListener('DOMContentLoaded', function () {
    // menu_init();
    nav_init();
    scroll_top_init();
    a11tyMenu();
    logoColor();
    iosFix();

    const scrollZoom = document.getElementsByClassName('wp-perf__scroll-zoom');

    if (scrollZoom.length > 0) {
        import('./modules/zoom-scroll').then((module) => {
            const ele = module.default;
            ele();
        });
    }
    const modal = document.getElementById('modal');
    if (modal !== null && modal !== undefined) {
        import('./modules/modal').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    const ajaxContainer = document.getElementById('wp-perf__ajax');
    if (ajaxContainer !== null && ajaxContainer !== undefined) {
        import('./modules/ajax').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    window.addEventListener('projects_init_complete', (event) => {
        const ajaxContainer = document.getElementById('wp-perf__ajax');
        if (ajaxContainer !== null && ajaxContainer !== undefined) {
            import('./modules/ajax').then((module) => {
                const ele = module.default;
                ele();
            });
        }

        loadCircleType();
    });

    const category_slider = document.getElementsByClassName('wp-perf__category-slider');
    if (category_slider && category_slider.length) {
        import('./modules/category-slider').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    const perf__tags = document.getElementsByClassName('wp-perf__tags');
    if (perf__tags && perf__tags.length) {
        import('./modules/tag-cloud').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    const wp_perf__filter = document.getElementsByClassName('wp-perf__filter');
    if (wp_perf__filter && wp_perf__filter.length) {
        import('./modules/filter').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    const perf__collapse = document.getElementsByClassName('wp-perf__collapse');
    if (perf__collapse && perf__collapse.length) {
        import('./modules/accordion').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    const swiper = document.getElementsByClassName('swiper');
    if (swiper && swiper.length) {
        import('./modules/swiper').then((module) => {
            const ele = module.default;
            ele();
        });
    }

    const wpadminbar = document.getElementById('wpadminbar');
    if (wpadminbar) {
        document.querySelector('body').classList.add('logged-in');
    }

    let pathname = window.location.pathname.replaceAll('/', '');
    if (!pathname.length) {
        pathname = 'start';
    }
    document.querySelector('body').classList.add('page__' + pathname);

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        document.querySelector('body').classList.add('mobile');
    }

    // const curved = document.querySelectorAll('.wp-perf__curved');
    // if (curved && curved.length) {

    //     import('./modules/curved-text').then((module) => {
    //         const ele = module.default;
    //         ele();
    //     });
    // }

    const loadCircleType = () => {
        const curved = document.querySelectorAll('.wp-perf__curved');
        if (curved && curved.length && typeof CircleType === 'undefined') {
            // Erstellen eines neuen Script-Tags für das CircleType-Skript
            const circleTypeScript = document.createElement('script');
            circleTypeScript.src = '/wp-content/themes/wp-perf-studio-leeflang/dist/vendor/circletype/circletype.min.js'; // Pfad zum CircleType-Skript anpassen
            circleTypeScript.onload = () => {
                // Skript ist geladen, jetzt das curved-text Modul laden
                import('./modules/curved-text').then((module) => {
                    const curvedText = module.default;
                    curvedText(); // Ausführen der Funktion aus dem curved-text Modul
                });
            };
            circleTypeScript.onerror = () => {
                console.error('Fehler beim Laden des CircleType-Skripts');
            };

            // Fügen Sie das Script-Tag zum Document hinzu
            document.head.appendChild(circleTypeScript);
        }
    };

    loadCircleType();
});
